<!-- 
 01-01-2025
 Copyright (c) 2016 Aruba. All Rights Reserved.  
 -->
<label class="d-none" for="contact" ></label>
<input id="contact" type="text" class="form-control" name="contact" formControlName="contact" 
(countrychange)="i18nizePhoneNumber()" #intlTelInput  apOnlyNumber>